var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-date-picker',_vm._g(_vm._b({staticClass:"ebp-date-picker"},'vue-date-picker',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }